import styled from 'styled-components';

/**
 * A name for a control the design system will not let us name directly.
 *
 * `BaseButton` derives its own `aria-label` from the button's text or icon and applies it AFTER
 * spreading the caller's props, so an `aria-label` passed in is dropped: an icon-only button ends
 * up announced as "edit" or "close" — the icon's name, not the action's. `aria-labelledby` is left
 * alone, and the accessible-name algorithm prefers it over `aria-label`, so pointing a control at
 * one of these is what gives it a name that says what it does.
 *
 * Hidden from sight but not from the accessibility tree, and kept out of the layout, so it can sit
 * beside the control it names. Delete it wherever the design system starts honouring `aria-label`.
 */
export const ControlName = styled.span`
	position: absolute;
	width: 1px;
	height: 1px;
	margin: -1px;
	padding: 0;
	border: 0;
	overflow: hidden;
	clip: rect(0 0 0 0);
	clip-path: inset(50%);
	white-space: nowrap;
`;
